// THAO TÁC NHANH trên từng dòng danh sách Kịch bản (08/10/2026): nút "⋯" mở menu ⧉ Nhân bản · ✎ Đổi tên (tại chỗ) · ⤓ Xuất · 🗑 Xoá (kich-ban-xoa.ts) (+ ★ Cấp phát).
// Nhân bản = POST /api/kich-ban/:id/nhan-ban (kịch bản MỚI của người bấm, Nháp, không mang lịch sử chạy) rồi mở bản sao; Super nhân bản kịch bản của Boss khác → hỏi
// trước (bản sao thuộc Super). Đổi tên = PATCH /api/kich-ban/:id {ten} (đúng API nút "Đổi tên" trên trang kịch bản — không đổi bản chạy, không phải chạy thử lại).
// Xuất = GET /api/kich-ban/:id/xuat, tệp đặt theo TÊN kịch bản (giữ tiếng Việt / emoji, bỏ ký tự cấm trong tên tệp).
// (danh sách kiểu bảng, 08/10/2026) mọi cỡ màn hình dùng CÙNG nút "⋯" + menu (trước đây ≥ 640 px hiện bốn nút chữ trên dòng). Mọi chữ dựng bằng textContent (tên có ' " < & \ an toàn).
import { api, errMsg } from "../api";
import { confirmBox, h, toast } from "../dom";

export interface DongThaoTac { id: string; ten: string; ownerId: string; ownerName: string | null }
const TEN_TOI_DA = 120;
const q = (s: string): string => `“${s}”`;

/** Tên tệp xuất từ tên kịch bản: bỏ ký tự cấm (\ / : * ? " < > | và ký tự điều khiển), gộp khoảng trắng, ≤ 80 ký tự (không cắt đôi emoji); rỗng → kb-<mã>. */
export function tenTepXuat(ten: string, id: string): string {
  let s = ten.normalize("NFC").replace(/[\u0000-\u001f\u007f<>:"/\\|?*]/g, " ").replace(/\s+/g, " ").trim().replace(/^[.\s]+|[.\s]+$/g, "");
  s = Array.from(s).slice(0, 80).join("").trim().replace(/[.\s]+$/g, "");
  if (/^(con|prn|aux|nul|com\d|lpt\d)$/i.test(s)) s = `kb-${s}`;
  return `${s || `kb-${id}`}.json`;
}

/** Kiểm tên mới như máy chủ (kich-ban-nhan.ts kiemTen): trả câu lỗi tiếng Việt hoặc null. */
export function loiTenMoi(v: string): string | null {
  const ten = v.replace(/\s+/g, " ").trim();
  if (!ten) return "Tên kịch bản không được để trống";
  const n = Array.from(ten).length;
  if (n > TEN_TOI_DA) return `Tên kịch bản quá dài (tối đa ${TEN_TOI_DA} ký tự — đang có ${n})`;
  return null;
}

let dangNhanBan = false; // khoá chung: bấm Nhân bản hai lần liên tiếp (hoặc hai dòng cùng lúc) chỉ tạo MỘT bản sao

// Bấm ĐÚP một mục menu: cú bấm thứ hai rơi xuống DÒNG nằm dưới menu vừa đóng (mở nhầm kịch bản gốc). Sau khi chọn một mục, 450 ms đầu cú bấm thứ hai (detail >= 2) lên dòng bị chặn.
let chanDen = 0;
if (typeof document !== "undefined") document.addEventListener("click", (e) => { if (Date.now() < chanDen && (e as MouseEvent).detail >= 2 && (e.target as Element | null)?.closest?.(".kb-dong-boc")) { e.preventDefault(); e.stopPropagation(); } }, true);
let dongMenuDangMo: (() => void) | null = null; // chỉ MỘT menu "⋯" mở tại một thời điểm (mở dòng khác thì dòng trước đóng)

/** Dòng danh sách: nút "⋯" mở menu Nhân bản / Đổi tên / Xuất / Xoá (+ ★ Cấp phát cho Super trên kịch bản của mình).
 *  `neo` = liên kết của dòng (ẩn khi đang sửa tên — ô sửa chèn ngay sau nó). Bàn phím: Enter/Space/↓ mở và dồn focus vào mục đầu, ↑↓ Home End di chuyển, Esc đóng
 *  (trả focus về ⋯), Tab đóng, bấm ra ngoài đóng. Nút trong menu giữ NGUYÊN mã kiểm thử cũ (kb-dong-nhan-ban…). */
export function nutDong(k: DongThaoTac, neo: HTMLElement, o: { laSuper: boolean; nguoiDungId: string; alive: () => boolean; capPhat?: () => void; xoa?: () => void }): HTMLElement {
  const cuaMinh = k.ownerId === o.nguoiDungId;
  const sua = o.laSuper || cuaMinh;
  const khoa = sua ? "" : "Kịch bản này không thuộc tài khoản của bạn";
  const tipNb = o.laSuper && !cuaMinh ? `Tạo bản sao (thuộc tài khoản Super của bạn) — cùng sơ đồ, sản phẩm, mong muốn; trạng thái Mới, chưa chạy lần nào` : "Tạo bản sao — cùng sơ đồ, sản phẩm, mong muốn; trạng thái Mới, chưa chạy lần nào, không mang hẹn giờ";
  const mucs: { tid: string; chu: string; tip: string; lam: () => void; moKhoa: boolean; nguy?: boolean }[] = [
    // (08/10/2026) ★ Cấp phát (Super, kịch bản của chính mình) — mở hộp chọn Boss nhận mẫu (kich-ban-5-sao.ts)
    ...(o.capPhat ? [{ tid: "kb-dong-cap-phat", chu: "★ Cấp phát", tip: "Cấp phát kịch bản này làm MẪU ★★★★★ cho mọi Boss hoặc Boss được chọn", lam: o.capPhat, moKhoa: !sua }] : []),
    { tid: "kb-dong-nhan-ban", chu: "⧉ Nhân bản", tip: tipNb, lam: () => void nhanBan(), moKhoa: !sua },
    { tid: "kb-dong-doi-ten", chu: "✎ Đổi tên", tip: "Đổi tên kịch bản ngay tại đây (Enter lưu, Esc huỷ)", lam: () => doiTen(), moKhoa: !sua },
    { tid: "kb-dong-xuat", chu: "⤓ Xuất", tip: "Tải tệp .json của kịch bản (nhập lại được bằng “Nhập tệp…”)", lam: () => void xuat(), moKhoa: !sua },
    ...(o.xoa ? [{ tid: "kb-dong-xoa", chu: "🗑 Xoá", tip: "Chuyển kịch bản này vào Thùng rác (khôi phục được trong 30 ngày)", lam: o.xoa, moKhoa: false, nguy: true }] : []),
  ];

  // ---- menu ⋯ ----
  const them = h("button", { type: "button", class: "kb-dong-them", "data-testid": "kb-dong-them", title: "Thao tác: Nhân bản / Đổi tên / Xuất / Xoá", "aria-label": `Thao tác khác cho ${q(k.ten)}`, "aria-haspopup": "menu", "aria-expanded": "false" }, "⋯");
  let menu: HTMLElement | null = null;
  const dongMenu = (): void => {
    if (!menu) return;
    menu.remove(); menu = null;
    them.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", ngoai, true);
    if (dongMenuDangMo === dongMenu) dongMenuDangMo = null;
  };
  const ngoai = (e: Event): void => { if (menu && !menu.contains(e.target as Node) && !them.contains(e.target as Node)) dongMenu(); };
  const cacMuc = (): HTMLButtonElement[] => (menu ? Array.from(menu.querySelectorAll<HTMLButtonElement>("button:not(:disabled)")) : []);
  const moMenu = (): void => {
    dongMenuDangMo?.();
    menu = h("div", { class: "kb-dong-menu", role: "menu", "aria-label": `Thao tác với ${q(k.ten)}`, "data-testid": "kb-dong-menu" },
      ...mucs.map((m) => {
        const b = h("button", { type: "button", role: "menuitem", class: `kb-dong-menu-muc${m.nguy ? " nguy" : ""}`, "data-testid": m.tid, disabled: m.moKhoa, title: m.moKhoa ? khoa : m.tip, "aria-label": `${m.chu.replace(/^\S+\s/, "")} ${q(k.ten)}` }, m.chu);
        b.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); chanDen = Date.now() + 450; dongMenu(); m.lam(); });
        return b;
      }));
    menu.addEventListener("keydown", (ev) => {
      const ds = cacMuc(), i = ds.indexOf(document.activeElement as HTMLButtonElement);
      if (ev.key === "Escape") { ev.preventDefault(); ev.stopPropagation(); dongMenu(); them.focus(); }
      else if (ev.key === "Tab") { dongMenu(); them.focus(); } // không chặn Tab: trình duyệt đi tiếp từ ⋯
      else if (ev.key === "ArrowDown") { ev.preventDefault(); ds[(i + 1) % ds.length]?.focus(); }
      else if (ev.key === "ArrowUp") { ev.preventDefault(); ds[(i - 1 + ds.length) % ds.length]?.focus(); }
      else if (ev.key === "Home") { ev.preventDefault(); ds[0]?.focus(); }
      else if (ev.key === "End") { ev.preventDefault(); ds[ds.length - 1]?.focus(); }
    });
    goc.append(menu);
    them.setAttribute("aria-expanded", "true");
    dongMenuDangMo = dongMenu;
    document.addEventListener("click", ngoai, true);
    // mở lên trên khi dưới không đủ chỗ (dòng cuối trang)
    const r = menu.getBoundingClientRect();
    if (r.bottom > window.innerHeight - 8 && them.getBoundingClientRect().bottom - r.height > 8) menu.classList.add("len");
    cacMuc()[0]?.focus();
  };
  them.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); if (menu) { dongMenu(); return; } moMenu(); });
  them.addEventListener("keydown", (e) => { if (e.key === "ArrowDown" && !menu) { e.preventDefault(); moMenu(); } });
  const goc = h("div", { class: "kb-dong-tt", "data-testid": "kb-dong-tt" }, them);

  // ---- Nhân bản ----
  async function nhanBan(): Promise<void> {
    if (dangNhanBan || !sua) return;
    dangNhanBan = true;
    try {
      if (o.laSuper && !cuaMinh) {
        const ok = await confirmBox({ title: "Nhân bản kịch bản của Boss khác?", text: `${q(k.ten)} là kịch bản của ${k.ownerName ?? "Boss khác"}. Bản sao sẽ thuộc tài khoản Super của BẠN (không thuộc ${k.ownerName ?? "Boss đó"}); bản gốc giữ nguyên.`, okText: "Nhân bản" });
        if (!ok) return;
      }
      const r = await api<{ id: string; ten: string }>("POST", `/api/kich-ban/${encodeURIComponent(k.id)}/nhan-ban`, {});
      toast(`Đã nhân bản → ${q(r.ten)} (Mới)`); // (08/10/2026, bỏ Nháp) chữ của mã "nhap" là "Mới" (kich-ban-nhan.ts TEN_NHAN)
      if (o.alive()) location.hash = `/kich-ban/${encodeURIComponent(r.id)}`;
    } catch (e) { toast(`Không nhân bản được: ${errMsg(e)}`, "err"); }
    finally { dangNhanBan = false; }
  }

  // ---- Đổi tên tại chỗ ----
  function doiTen(): void {
    const cha = neo.parentElement;
    if (!sua || !cha || cha.querySelector(".kb-dong-sua")) return;
    const o2 = h("input", { type: "text", value: k.ten, maxlength: 400, "data-testid": "kb-dong-ten-o", "aria-label": `Tên mới của kịch bản ${q(k.ten)}`, title: `Tối đa ${TEN_TOI_DA} ký tự · Enter lưu · Esc huỷ` });
    const loi = h("span", { class: "err small", "data-testid": "kb-dong-ten-loi", role: "alert", hidden: true });
    const luu = h("button", { type: "button", class: "pri mini", "data-testid": "kb-dong-ten-luu", title: "Lưu tên mới (Enter)" }, "Lưu");
    const huy = h("button", { type: "button", class: "mini", "data-testid": "kb-dong-ten-huy", title: "Giữ tên cũ (Esc)" }, "Huỷ");
    const khung = h("div", { class: "kb-dong-sua", "data-testid": "kb-dong-sua" }, h("div", { class: "kb-dong-sua-hang" }, o2, luu, huy), loi);
    let dangLuu = false;
    const xong = (): void => { khung.remove(); neo.hidden = false; goc.hidden = false; };
    const baoLoi = (s: string): void => { loi.textContent = s; loi.hidden = false; o2.setAttribute("aria-invalid", "true"); o2.focus(); };
    const gui = async (): Promise<void> => {
      if (dangLuu) return;
      const sai = loiTenMoi(o2.value);
      if (sai) { baoLoi(sai); return; }
      const moi = o2.value.replace(/\s+/g, " ").trim();
      if (moi === k.ten) { xong(); return; }
      dangLuu = true; luu.disabled = true; luu.textContent = "…";
      try {
        const r = await api<{ ten: string }>("PATCH", `/api/kich-ban/${encodeURIComponent(k.id)}`, { ten: moi });
        k.ten = r.ten;
        const chu = neo.querySelector(".kb-dong-ten");
        if (chu) chu.textContent = r.ten;
        toast("Đã đổi tên");
        xong();
      } catch (e) { baoLoi(errMsg(e)); }
      finally { dangLuu = false; luu.disabled = false; luu.textContent = "Lưu"; }
    };
    luu.addEventListener("click", (e) => { e.preventDefault(); void gui(); });
    huy.addEventListener("click", (e) => { e.preventDefault(); xong(); neo.focus(); });
    o2.addEventListener("input", () => { loi.hidden = true; o2.removeAttribute("aria-invalid"); });
    o2.addEventListener("keydown", (e) => {
      if (e.key === "Enter") { e.preventDefault(); void gui(); }
      else if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); xong(); neo.focus(); }
    });
    neo.hidden = true; goc.hidden = true;
    neo.after(khung);
    o2.focus(); o2.select();
  }

  // ---- Xuất ----
  let dangXuat = false;
  async function xuat(): Promise<void> {
    if (dangXuat || !sua) return;
    dangXuat = true;
    try {
      const res = await fetch(`/api/kich-ban/${encodeURIComponent(k.id)}/xuat`, { credentials: "same-origin" });
      if (!res.ok) { const j = await res.json().catch(() => null) as { error?: { message?: string } } | null; throw new Error(j?.error?.message ?? `Máy chủ trả lỗi HTTP ${res.status}`); }
      const url = URL.createObjectURL(await res.blob());
      const a = h("a", { href: url, download: tenTepXuat(k.ten, k.id), hidden: true });
      document.body.append(a); a.click(); a.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 5000);
      toast(`Đã xuất ${q(k.ten)}`);
    } catch (e) { toast(`Không xuất được: ${errMsg(e)}`, "err"); }
    finally { dangXuat = false; }
  }

  return goc;
}
